<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="issuerName"
    type="text"
    placeholder="Search by company name"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'issuerName')"
  />
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="cikNumber"
    type="text"
    placeholder="Search by cik number"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'cikNumber')"
  />
</div>

<div class="mb-4"></div>

<p-table
  [value]="processedIssuers"
  [paginator]="processedIssuers.length > 0"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [(selection)]="selectedIssuers"
  dataKey="asReportedIssuerId"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th>ID</th>
      <th>Issuer Name</th>
      <th>CIK</th>
      <th>EIN</th>
      <th>SIC</th>
      <th>File No</th>
      <th>Year End</th>
      <th>State of Incorporation</th>
      <th>Actions</th>
    </tr>
  </ng-template>
  <ng-template #body let-issuer>
    <tr>
      <td>
        {{ issuer.issuerId || "N/A" }}
      </td>

      <td>{{ issuer.issuerName || "N/A" }}</td>
      <td>{{ issuer.cikNumber || "N/A" }}</td>
      <td>{{ issuer.ein || "N/A" }}</td>
      <td>{{ issuer.sicNumber || "N/A" }}</td>
      <td>{{ issuer.fileNumber || "N/A" }}</td>

      <td>{{ issuer.fiscalYearEnd || "N/A" }}</td>
      <td>{{ issuer.stateOfIncorporation || "N/A" }}</td>
      <td>
        <button
          class="bg-[#1f273b] cursor-pointer text-white py-1 px-3 border border-gray-400 rounded mr-2"
          (click)="onUpdateClick(issuer)"
        >
          Update
        </button>
        <button
          class="bg-white cursor-pointer hover:bg-gray-100 text-gray-800 py-1 px-3 border border-gray-400 rounded"
          (click)="onDetailClick(issuer)"
        >
          Detail
        </button>

        <button
          *ngIf="issuer.is_deletable"
          class="bg-red-600 hover:bg-red-700 text-white py-1 px-3 border border-gray-400 rounded"
          (click)="onDeleteClick(issuer)"
        >
          Delete
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-toast></p-toast>

<ng-container *ngIf="!isLoading && processedIssuers.length === 0">
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-container>
